import user from './user';
import { combineReducers } from 'redux'; //eslint-disable-line
export default combineReducers({
  user,
});
